import * as React from 'react';
import { ToneDto } from '../../../../core/dto/tonedto';
import { ArtistRowComponent } from './artistrowcomponent';
import { PaginationListViewModelImpl } from '../../verticallist/paginationverticallist/paginationlistviewmodel';


export class ArtistViewModelImpl extends PaginationListViewModelImpl<ToneDto>
{
    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        return <ArtistRowComponent key={position}  context={this.getContext()} artistDto={t}  position={position}/>;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/artist/artistviewmodel.tsx